import { Component, Vue } from "vue-property-decorator";
import { isIINBIN } from "@/utils";
import { ID_INDIVIDUAL, ID_LEGAL_ENTITY } from "@/config/const";

@Component
export default class extends Vue {
  protected formRef = "form-validator-ref";
  get rules() {
    return {
      required: (value: string) => {
        return typeof value === "boolean" || typeof value === "number"
          ? true
          : !!value || this.$t("Обязательное поле");
      },
      stringLengthMaxMin: (max: number, min?: number) => (value: string) => {
        if (max && value.length > max) {
          return this.$t("stringMax", [max]);
        } else if (min && value.length < min) {
          return this.$t("stringMin", [min]);
        }
        return true;
      },
      email: (value: string) => {
        const cyrillicPattern = /[а-яА-ЯЁё]/;
        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (
          (!cyrillicPattern.test(value) && emailPattern.test(value)) ||
          this.$t("invalidEmail")
        );
      },
      iin: () => this.iinBin("iin"),
      bin: () => this.iinBin("bin"),
      iinOrBin: () => this.iinBin("iinOrBin"),
      numberMaxMin: (value: string, max: number, min: number) => {
        if (isNaN(Number(value))) {
          return this.$t("Не число");
        }
        const number = Number(value);
        if (typeof number === "number") {
          if (typeof max === "number" && number > max) {
            return this.$t("maxValidator", [
              max.toLocaleString("ru-RU", {
                maximumFractionDigits: 3,
              }),
            ]);
          } else if (typeof min === "number" && number < min) {
            return this.$t(`Не должно быть меньше ${min}`);
          }
        } else {
          return this.$t("Некорректное число");
        }
        return true;
      },
    };
  }

  validateForm() {
    //!!во всех компонентах которые используют этот примесь нужно в компоненте указать formRef-ссылка на контейнер формы
    return (this.$refs[this.formRef] as Vue & {
      validate: () => boolean;
    }).validate();
  }

  private iinBin(type: "iin" | "bin" | "iinOrBin") {
    return (value: string) => {
      if (!value) return true;
      const res = isIINBIN(value);
      const errMessage = this.$t("wrong", [this.$t(type)]);
      return (
        (type == "iinOrBin" && !!res) ||
        (type === "iin" && res === ID_INDIVIDUAL) ||
        (type === "bin" && res === ID_LEGAL_ENTITY) ||
        errMessage
      );
    };
  }
}
